/**
 * Copyright (C) 2021-2026 Technology Matters
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see https://www.gnu.org/licenses/.
 */

import { Box } from '@twilio-paste/core/box';
import { Text } from '@twilio-paste/core/text';
import { Button } from '@twilio-paste/core/button';
import { useDispatch } from 'react-redux';

import { sessionDataHandler } from '../sessionDataHandler';
import { changeEngagementPhase, updatePreEngagementData } from '../store/actions/genericActions';
import { EngagementPhase } from '../store/definitions';
import { containerStyles, textStyles, titleStyles } from './styles/ConversationEnded.styles';
import { useClearParticipantNameMap } from '../hooks/useClearParticipantNameMap';
import LocalizedTemplate from '../localization/LocalizedTemplate';

export const ConversationEnded = () => {
  const dispatch = useDispatch();

  useClearParticipantNameMap();

  const handleStartNewChat = () => {
    sessionDataHandler.clear();
    dispatch(updatePreEngagementData({}));
    dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
  };

  return (
    <Box {...containerStyles}>
      <Text as="h3" {...titleStyles}>
        <LocalizedTemplate code="MessagePhase-ConversationEnded-Heading" />
      </Text>
      <Text as="p" {...textStyles}>
        <LocalizedTemplate code="MessagePhase-ConversationEnded-Detail" />
      </Text>
      <Button variant="primary" data-testid="start-new-chat-button" onClick={handleStartNewChat}>
        <LocalizedTemplate code="MessagePhase-ConversationEnded-ButtonText" />
      </Button>
    </Box>
  );
};
